import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { compareStringsCaseInsensitively } from '../../../../utils/miscellaneous/compareStrings';
import { languageTypes } from '../../../../constants/common/languageTypes';
import { getLanguage } from '../../../../reducers/appReducer';


function Announcements({ announcements, language }) {

    const getAnnouncements = () => {
        const englishAnnouncements = announcements.filter(ann => (ann.lookupLocale && compareStringsCaseInsensitively(ann.lookupLocale.localeCode,languageTypes.ENGLISH) || ann.lookupLocale === null));

        let payloadForRender;
        switch(language) {
            case languageTypes.ENGLISH:
                payloadForRender = englishAnnouncements;
                break;
            case languageTypes.SPANISH:
                payloadForRender = englishAnnouncements.map(announcement => {
                    const { announcementCode } = announcement;
                    const matchedAnnouncement = announcements.find(announcement => {
                        return announcement.announcementCode === announcementCode && announcement.lookupLocale && compareStringsCaseInsensitively(announcement.lookupLocale.localeCode, languageTypes.SPANISH);
                    });
                    return matchedAnnouncement ? matchedAnnouncement : announcement;
                });
                break;
            default:
                return englishAnnouncements;
        }


        return (
            <Fragment>
                {
                    payloadForRender.map(i => {
                        return (
                            <div key={i.id} dangerouslySetInnerHTML={{ __html: i.announcementText }}></div>
                        );
                    })
                }
            </Fragment>
        );
    };
    return getAnnouncements();
}

const mapStateToProps = state => ({
    language: getLanguage(state)
});
export default connect(mapStateToProps)(Announcements);